import {Injectable} from '@angular/core';
import {environment} from '../../../../src/environments/environment';
import {HttpClient} from '@angular/common/http';
import {EMPTY, Observable} from 'rxjs';
import {DashboardApiService} from '../dashboard/dashboard-api.service';
import {ObjectApiService} from '../object/object-api.service';
import {UnitsApiService} from '../unit/units-api.service';
import {ObjrubricModel} from './objrubric.model';
import {catchError, shareReplay} from 'rxjs/operators';
import {ParentApiService, SingleRESTService} from '../../../../src/app/API/apiService';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {fromPromise} from 'rxjs/internal/observable/innerFrom';
import {RoomModel} from '../room/room.model';

@Injectable()
export class ObjrubricApiService extends ParentApiService implements Resolve<ObjrubricModel>, SingleRESTService<ObjrubricModel> {

  private baseUrl = environment.backEndUrlPrefix + '/' + 'db/objrubric';

  constructor(private http: HttpClient,
              public dashboardService: DashboardApiService,
              public unitsApiService: UnitsApiService,
              public objectApiService: ObjectApiService) {
    super();
  }

  getAll(): Observable<ObjrubricModel[]> {
    const code = 'all';
    let cache = this.getCache(code);
    if (!cache) {
      cache = this.http.get<ObjrubricModel[]>(this.baseUrl).pipe(
        shareReplay(1),
        catchError(err => {
          delete this.cache[code];
          return EMPTY;
        }));
      this.setCache(code, cache);
    } else {
    }
    return cache;
  }

  deleteGroup(ids: number[]) {
    return this.http.delete<string>(this.baseUrl, {params: {id: ids.map(id => String(id))}});
  }

  public getTreeRubrics(selected = null): Observable<any> {
    return fromPromise(new Promise((resolve, reject) => {
      this.getAll().subscribe(rubrics => {
        const nth = (item, level = 0) => (item && item.objrubric) ? nth(item.objrubric, level + 1) : level;
        rubrics.sort((item1, item2) =>
          nth(item1) - nth(item2)
        );
        const res = [];
        rubrics.forEach(item => {
          if (!item.objrubric) {
            res.push({
              label: item.shortname,
              key: item.id,
              id: item.id,
              isDashboard: false,
              expandedIcon: 'fa fa-folder-open',
              collapsedIcon: 'fa fa-folder',
            });
            if (selected === item.id) {
            }
          } else {

            const parent = this.findElement(res, item.objrubric.id);
            if (!parent) {
              res.push({
                label: item.shortname,
                key: item.id,
                id: item.id,
                isDashboard: false,
                expandedIcon: 'fa fa-folder-open',
                collapsedIcon: 'fa fa-folder',
              });
            } else {
              if (!parent.children) {
                parent.children = [];
              }
              if (selected === item.id) {
                this.expandItem(parent);
              }
              parent.children.push({
                label: item.shortname,
                key: item.id,
                id: item.id,
                isDashboard: false,
                parent,
                expandedIcon: 'fa fa-folder-open',
                collapsedIcon: 'fa fa-folder',
              });
            }
          }
        });
        resolve(res);
      });
    }));
  }

  public getTreeObjects(clearEmpty: boolean = false): Observable<any> {
    return fromPromise(new Promise(((resolve, reject) => {
      const objectsList = this.objectApiService.getAll();
      const rubs = this.getAll();
      objectsList.subscribe(objects => {
        rubs.subscribe(rubrics => {
          resolve(this.createObjectTree(objects, rubrics, clearEmpty));
        });
      });

    })));
  }



  public createPlacesTree(objects, rubrics, clearEmpty: boolean = false, existTree = {}) { // TODO: Костыли для деревьев в API сервисах - вынести в отдельный сервис
    if (!objects) {
      return;
    }
    const nth = (item, level = 0) => (item && item.objrubric) ? nth(item.objrubric, level + 1) : level;
    rubrics.sort((item1, item2) =>
      nth(item1) - nth(item2)
    );

    objects.sort((item1, item2) => item1.shortname.localeCompare(item2.shortname));

    let res = [];
    rubrics.forEach(item => {
      if (!item.objrubric) {
        res.push({
          label: item.shortname,
          data: item,
          key: `rubric${item.id}`,
          id: item.id,
          count: 0,
          statuses: {},
          childCount: 0,
          state: -1,
          isObject: false,
          selectable: true,
          styleClass: 'object-tree-node',
          expandedIcon: 'fa fa-folder-open',
          collapsedIcon: 'fa fa-folder',
        });
      } else {

        const parent = this.findElement(res, item.objrubric.id);
        if (!parent) {
          res.push({
            label: item.shortname,
            data: item,
            key: `rubric${item.id}`,
            id: item.id,
            count: 0,
            state: -1,
            statuses: {},
            isObject: false,
            selectable: true,
            styleClass: 'object-tree-node',
            expandedIcon: 'fa fa-folder-open',
            collapsedIcon: 'fa fa-folder',
          });
        } else {
          if (!parent.children) {
            parent.children = [];
          }
          parent.children.push({
            label: item.shortname,
            key: `rubric${item.id}`,
            data: item,
            count: 0, // количество дочерних параметров
            state: -1, //  максимальны статус дочернего параметра
            parent,
            statuses: {},  // статусы всех дочерних объектов
            childCount: 0, // общее количество дочерних объектов
            id: item.id,
            isObject: false,
            selectable: true,
            styleClass: 'object-tree-node',
            expandedIcon: 'fa fa-folder-open',
            collapsedIcon: 'fa fa-folder',
          });
        }
      }
    });

    objects.forEach(item => {
      const parent = this.findElement(res, item.objrubric.id);
      if (!parent) {
        res.push({
          label: item.shortname,
          data: item,
          key: `object${item.id}`,
          id: item.id,
          count: 0,
          state: -1,
          statuses: {},  // статусы всех дочерних объектов
          isObject: false,
          selectable: true,
          styleClass: 'object-tree-node',
          expandedIcon: 'fa fa-folder-open',
          collapsedIcon: 'fa fa-folder',
        });
      } else {
        this.recountParent(parent, item.worstparamcount, item.worstparamstate.id);

        if (!parent.children) {
          parent.children = [];
        }
        parent.children.push({
          label: item.shortname,
          key: `object${item.id}`,
          id: item.id,
          count: item.worstparamcount,
          data: item,
          paramtags: item.paramtags,
          sdirobjectstate: item.sdirobjectstate,
          worstparamstate: item.worstparamstate,
          isObject: true,
          selectable: true,
          parent,
          styleClass: 'object-tree-node',
          state: item.worstparamstate.id,
          icon: 'fa',
          children: item.sensorLocations.map(l => ({
            label: `${l.name}`,
            key: `object${item.id}-location${l.id}`,
            id: l.id,
            parent,
            data: item,
            count: 0,
            styleClass: 'object-tree-node',
            isPlace: true,
          }))
        });
      }
    });
    if (clearEmpty) {
      res = this.clearEmptyRubrics(res);
    }
    return res;
  }

  public createObjectTree(objects, rubrics, clearEmpty: boolean = false, existTree = {}) { // TODO: Костыли для деревьев в API сервисах - вынести в отдельный сервис
    if (!objects) {
      return;
    }
    const nth = (item, level = 0) => (item && item.objrubric) ? nth(item.objrubric, level + 1) : level;
    rubrics.sort((item1, item2) =>
      nth(item1) - nth(item2)
    );

    objects.sort((item1, item2) => item1.shortname.localeCompare(item2.shortname));

    let res = [];
    rubrics.forEach(item => {
      if (!item.objrubric) {
        res.push({
          label: item.shortname,
          data: item,
          key: `rubric${item.id}`,
          id: item.id,
          count: 0,
          statuses: {},
          childCount: 0,
          state: -1,
          isObject: false,
          selectable: true,
          styleClass: 'object-tree-node',
          expandedIcon: 'fa fa-folder-open',
          collapsedIcon: 'fa fa-folder',
        });
      } else {

        const parent = this.findElement(res, item.objrubric.id);
        if (!parent) {
          res.push({
            label: item.shortname,
            data: item,
            key: `rubric${item.id}`,
            id: item.id,
            count: 0,
            state: -1,
            statuses: {},
            isObject: false,
            selectable: true,
            styleClass: 'object-tree-node',
            expandedIcon: 'fa fa-folder-open',
            collapsedIcon: 'fa fa-folder',
          });
        } else {
          if (!parent.children) {
            parent.children = [];
          }
          parent.children.push({
            label: item.shortname,
            key: `rubric${item.id}`,
            data: item,
            count: 0, // количество дочерних параметров
            state: -1, //  максимальны статус дочернего параметра
            parent,
            statuses: {},  // статусы всех дочерних объектов
            childCount: 0, // общее количество дочерних объектов
            id: item.id,
            isObject: false,
            selectable: true,
            styleClass: 'object-tree-node',
            expandedIcon: 'fa fa-folder-open',
            collapsedIcon: 'fa fa-folder',
          });
        }
      }
    });

    objects.forEach(item => {
      const parent = this.findElement(res, item.objrubric.id);
      if (!parent) {
        res.push({
          label: item.shortname,
          data: item,
          key: `object${item.id}`,
          id: item.id,
          count: 0,
          state: -1,
          statuses: {},  // статусы всех дочерних объектов
          isObject: false,
          selectable: true,
          styleClass: 'object-tree-node',
          expandedIcon: 'fa fa-folder-open',
          collapsedIcon: 'fa fa-folder',
        });
      } else {
        this.recountParent(parent, item.worstparamcount, item.worstparamstate.id);

        if (!parent.children) {
          parent.children = [];
        }
        parent.children.push({
          label: item.shortname,
          key: `object${item.id}`,
          id: item.id,
          count: item.worstparamcount,
          data: item,
          paramtags: item.paramtags,
          sdirobjectstate: item.sdirobjectstate,
          worstparamstate: item.worstparamstate,
          isObject: true,
          selectable: true,
          parent,
          styleClass: 'object-tree-node',
          state: item.worstparamstate.id,
          icon: 'fa'
        });
      }
    });
    if (clearEmpty) {
      res = this.clearEmptyRubrics(res);
    }
    return res;
  }

  copyExpanded(objects, existTree) {

    objects = objects.map((object, ind) => {
      if (existTree && existTree[ind]) {
        object.expanded = existTree[ind].expanded;
        if (object.children) {
          object.children = this.copyExpanded(object.children, existTree[ind].children);
        }
        return object;
      } else {
        return object;
      }
    });

    return objects;
  }

  recountParent(item, count, state) {
    item.count += count;
    item.state = Math.max(state, item.state);
    if (!item.statuses) {
      item.statuses = {};
    }
    if (!item.statuses[state]) {
      item.statuses[state] = 0;
    }
    item.childCount++;
    item.statuses[state]++;
    if (item.parent) {
      this.recountParent(item.parent, count, state);
    }
  }

  public getTreeDevices(clearEmpty: boolean = false): Observable<any> {
    return fromPromise(new Promise(((resolve, reject) => {
      const objectsList = this.objectApiService.getAll();
      const getDevices = this.unitsApiService.getAll();
      const rubs = this.getAll();
      objectsList.subscribe(objects => {
        rubs.subscribe(rubrics => {
          getDevices.subscribe(devices => {
            resolve(this.createDevicesTree(objects, rubrics, devices, clearEmpty));
          });
        });
      });
    })));
  }

  public createDevicesTree(objects, rubrics, devices, clearEmpty: boolean = false) {
    rubrics.sort((item1, item2) =>
      (item1.objrubric ? item1.objrubric.id : 0) - (item2.objrubric ? item2.objrubric.id : 0)
    );

    let res = [];
    rubrics.forEach(item => {
      if (!item.objrubric) {
        res.push({
          label: item.shortname,
          key: item.id,
          id: item.id,
          count: 0,
          state: -1,
          data: item,
          isObject: false,
          styleClass: 'object-tree-node',
          expandedIcon: 'fa fa-folder-open',
          collapsedIcon: 'fa fa-folder',
        });
      } else {

        const parent = this.findElement(res, item.objrubric.id);
        if (!parent) {
          res.push({
            label: item.shortname,
            key: item.id,
            id: item.id,
            count: 0,
            state: -1,
            data: item,
            isObject: false,
            statuses: {},  // статусы всех дочерних объектов
            styleClass: 'object-tree-node',
            expandedIcon: 'fa fa-folder-open',
            collapsedIcon: 'fa fa-folder',
          });
        } else {
          if (!parent.children) {
            parent.children = [];
          }
          parent.children.push({
            label: item.shortname,
            key: item.id,
            id: item.id,
            data: item,
            count: 0,
            state: -1,
            parent,
            isObject: false,
            statuses: {},  // статусы всех дочерних объектов
            styleClass: 'object-tree-node',
            expandedIcon: 'fa fa-folder-open',
            collapsedIcon: 'fa fa-folder',
          });
        }
      }
    });


    objects.forEach(item => {
      const parent = this.findElement(res, item.objrubric.id);
      if (!parent) {
        res.push({
          label: item.shortname,
          key: item.id,
          id: item.id,
          count: 0,
          state: -1,
          data: item,
          isObject: false,
          styleClass: 'object-tree-node',
          expandedIcon: 'fa fa-folder-open',
          collapsedIcon: 'fa fa-folder',
        });
      } else {
        this.recountParent(parent, item.worstparamcount, item.worstparamstate.id);
        if (!parent.children) {
          parent.children = [];
        }
        const object = {
          label: item.shortname,
          key: item.id,
          id: item.id,
          data: item,
          count: item.worstparamcount,
          paramtags: item.paramtags,
          sdirobjectstate: item.sdirobjectstate,
          worstparamstate: item.worstparamstate,
          isObject: true,
          state: item.worstparamstate.id,
          parent,
          styleClass: 'object-tree-node',
          children: [],
          icon: 'fa'
        };

        devices.forEach(device => {
          if (device.controller.object.id === item.id) {
            object.children.push({
              label: `${device.deviceconnect.connectname} (${device.deviceconnect.device.devicename})`,
              key: device.id,
              id: device.id,
              parent,
              unitState: device.state,
              available: device.available,
              data: item,
              count: 0,
              styleClass: 'object-tree-node',
              isDevice: true,
            });
          }
        });
        parent.children.push(object);
      }
    });
    if (clearEmpty) {
      res = this.clearEmptyRubrics(res);
    }
    return res;
  }

  public createRoomsTree(objects, rubrics, rooms, clearEmpty: boolean = false) {
    rubrics.sort((item1, item2) =>
      (item1.objrubric ? item1.objrubric.id : 0) - (item2.objrubric ? item2.objrubric.id : 0)
    );

    let res = [];
    rubrics.forEach(item => {
      if (!item.objrubric) {
        res.push({
          label: item.shortname,
          key: item.id,
          id: item.id,
          count: 0,
          state: -1,
          data: item,
          isObject: false,
          styleClass: 'object-tree-node',
          expandedIcon: 'fa fa-folder-open',
          collapsedIcon: 'fa fa-folder',
        });
      } else {

        const parent = this.findElement(res, item.objrubric.id);
        if (!parent) {
          res.push({
            label: item.shortname,
            key: item.id,
            id: item.id,
            count: 0,
            state: -1,
            data: item,
            isObject: false,
            statuses: {},  // статусы всех дочерних объектов
            styleClass: 'object-tree-node',
            expandedIcon: 'fa fa-folder-open',
            collapsedIcon: 'fa fa-folder',
          });
        } else {
          if (!parent.children) {
            parent.children = [];
          }
          parent.children.push({
            label: item.shortname,
            key: item.id,
            id: item.id,
            data: item,
            count: 0,
            state: -1,
            parent,
            isObject: false,
            statuses: {},  // статусы всех дочерних объектов
            styleClass: 'object-tree-node',
            expandedIcon: 'fa fa-folder-open',
            collapsedIcon: 'fa fa-folder',
          });
        }
      }
    });


    objects.forEach(item => {
      const parent = this.findElement(res, item.objrubric.id);
      if (!parent) {
        res.push({
          label: item.shortname,
          key: item.id,
          id: item.id,
          count: 0,
          state: -1,
          data: item,
          isObject: false,
          styleClass: 'object-tree-node',
          expandedIcon: 'fa fa-folder-open',
          collapsedIcon: 'fa fa-folder',
        });
      } else {
        this.recountParent(parent, item.worstparamcount, item.worstparamstate.id);
        if (!parent.children) {
          parent.children = [];
        }
        const object = {
          label: item.shortname,
          key: item.id,
          id: item.id,
          data: item,
          count: item.worstparamcount,
          paramtags: item.paramtags,
          sdirobjectstate: item.sdirobjectstate,
          worstparamstate: item.worstparamstate,
          isObject: true,
          state: item.worstparamstate.id,
          parent,
          styleClass: 'object-tree-node',
          children: [],
          icon: 'fa'
        };
        const objRooms = rooms.filter(room => room.object.id === object.id);
        if (objRooms.length > 0) {
          const sortedRooms = this.sortedByParents(objRooms, item, parent);
          object.children = sortedRooms;
        }

        parent.children.push(object);
      }
    });
    if (clearEmpty) {
      res = this.clearEmptyRubrics(res);
    }
    return res;
  }


  public getTreeDashboards(clearEmpty: boolean, showHidden = false, dashboards?: any[]): Observable<any> {
    return fromPromise(new Promise(((resolve, reject) => {
      const rubs = this.getAll();
      {
        const filteredDashboards = dashboards ? dashboards.filter(tmpDash => {
          if (showHidden) {
            return true;
          }
          return tmpDash.hidden === false;
        }) : [];
        rubs.subscribe(rubrics => {
          const nth = (item, level = 0) => (item && item.objrubric) ? nth(item.objrubric, level + 1) : level;

          rubrics.sort((item1, item2) =>
            nth(item1) - nth(item2)
          );


          let res = [];
          rubrics.forEach(item => {
            if (!item.objrubric) {
              res.push({
                label: item.shortname,
                key: item.id,
                id: item.id,
                isDashboard: false,
                expandedIcon: 'fa fa-folder-open',
                collapsedIcon: 'fa fa-folder',
              });
            } else {

              const parent = this.findElement(res, item.objrubric.id);
              if (!parent) {
                res.push({
                  label: item.shortname,
                  key: item.id,
                  id: item.id,
                  isDashboard: false,
                  expandedIcon: 'fa fa-folder-open',
                  collapsedIcon: 'fa fa-folder',
                });
              } else {
                if (!parent.children) {
                  parent.children = [];
                }
                parent.children.push({
                  label: item.shortname,
                  key: item.id,
                  id: item.id,
                  isDashboard: false,
                  expandedIcon: 'fa fa-folder-open',
                  collapsedIcon: 'fa fa-folder',
                });
              }
            }
          });


          filteredDashboards.forEach(item => {
            const parent = this.findElement(res, item.objrubric.id);
            let isWeb = true;
            if ((item as any).type && (item as any).type === 'MOBILE' ) {
              isWeb = false;
            }
            if (!parent.children) {
              parent.children = [];
            }
            parent.children.push({
              label: item.dashname,
              key: item.id,
              id: item.id,
              hiddenDash: item.hidden,
              isDashboard: true,
              icon: isWeb ? 'fa fa-tachometer' : 'fa fa-mobile'
            });
          });
          if (clearEmpty) {
            res = this.clearEmptyRubrics(res);
          }
          resolve(res);
        });
      }
    })));
  }

  public getRubricTree(clearEmpty: boolean, showHidden = false): Observable<any> {
    return fromPromise(new Promise(((resolve, reject) => {
      const rubs = this.getAll();
      {
        rubs.subscribe(rubrics => {
          const nth = (item, level = 0) => (item && item.objrubric) ? nth(item.objrubric, level + 1) : level;

          rubrics.sort((item1, item2) =>
            nth(item1) - nth(item2)
          );


          let res = [];
          rubrics.forEach(item => {
            if (!item.objrubric) {
              res.push({
                label: item.shortname,
                key: item.id,
                id: item.id,
                isDashboard: false,
                expandedIcon: 'fa fa-folder-open',
                collapsedIcon: 'fa fa-folder',
              });
            } else {

              const parent = this.findElement(res, item.objrubric.id);
              if (!parent) {
                res.push({
                  label: item.shortname,
                  key: item.id,
                  id: item.id,
                  isDashboard: false,
                  expandedIcon: 'fa fa-folder-open',
                  collapsedIcon: 'fa fa-folder',
                });
              } else {
                if (!parent.children) {
                  parent.children = [];
                }
                parent.children.push({
                  label: item.shortname,
                  key: item.id,
                  id: item.id,
                  isDashboard: false,
                  expandedIcon: 'fa fa-folder-open',
                  collapsedIcon: 'fa fa-folder',
                });
              }
            }
          });
          resolve(res);
        });
      }
    })));
  }



  clearEmptyRubrics(res) {
    const countChildren = (value) => value.children ? value.children.length : 0;
    res = res.map(val => {
      if (val.children) {
        val.children = this.clearEmptyRubrics(val.children);
      }
      return val;
    });

    res = res.filter(val => countChildren(val) > 0 || val.isDashboard || val.isObject);

    return res;
  }

  findElement(elements, id) {
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].id === id && !elements[i].isDevice && !elements[i].isObject && !elements[i].isDashboard) {
        return elements[i];
      } else if (elements[i].id === id && elements[i].isPlace) {
        return elements[i];
      }
      if (elements[i].children) {
        const el = this.findElement(elements[i].children, id);
        if (el) {
          return el;
        }
      }
    }

  }

  getNewObjrubric(): ObjrubricModel {
    return {};
  }

  create(data: ObjrubricModel): Observable<ObjrubricModel> {
    return this.http.post<ObjrubricModel>(`${this.baseUrl}`, data);
  }

  save(objrubricId: number, data: ObjrubricModel): Observable<ObjrubricModel> {
    return this.http.put<ObjrubricModel>(`${this.baseUrl}/${objrubricId}`, data);
  }

  byId(objrubricId): Observable<ObjrubricModel> {
    return this.http.get<ObjrubricModel>(this.baseUrl + `/${objrubricId}`);
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ObjrubricModel> | Promise<ObjrubricModel> | ObjrubricModel {
    return this.byId(route.params.objrubricId);
  }

  private expandItem(item) {
    item.expanded = true;
    if (item.parent) {
      this.expandItem(item.parent);
    }
  }

  private sortedByParents(rooms: RoomModel[], item: any, parent: any): any[] {
    let sortedRooms: any[] = [];
    rooms.forEach(room => {
      if (!room.parent) {
        let children = this.sortBySubParents(room, rooms, item);
        sortedRooms.push({
          label: `${room.name} (${room.sensorLocation?.name})`,
          key: room.id,
          id: room.id,
          sensorLocationId: room.sensorLocation?.id,
          parent,
          data: item,
          count: 0,
          children: children,
          styleClass: 'object-tree-node',
          isPlace: true,
        });

        //sortedRooms.push(room);
      }
    });
    return sortedRooms;
  }
  private sortBySubParents(parent: RoomModel, rooms: RoomModel[], item: any): any[] {
    let sortedRooms: any[] = [];
    let children: any[] = rooms.filter(room => room.parent?.id === parent.id);
    if (children.length > 0) {
      children.forEach(room => {
        let children = this.sortBySubParents(room, rooms, item);
        sortedRooms.push({
          label: `${room.name} (${room.sensorLocation?.name})`,
          key: room.id,
          id: room.id,
          sensorLocationId: room.sensorLocation?.id,
          parent,
          data: item,
          count: 0,
          children: children,
          styleClass: 'object-tree-node',
          isPlace: true,
        });
        //sortedRooms.push(room);
      });
    }
    return sortedRooms;
  }

}
